import AuthLayout from "@/layout/AuthLayout.tsx";
import InviteForm from "@/components/formik/InviteForm.tsx";

export default function InviteView() {
    return (
        <AuthLayout>
            <InviteForm/>
        </AuthLayout>
    );
}
